module.exports = __webpack_public_path__ + "static/trainingslagerreisen-9a1c97af8b7af1db4ef5646a1f7758a7.svg";